export default "__VITE_ASSET__DwcIur6$__"